export enum AutomationTypeEnum {
  TICKETING_QUEUES = "TICKETING_QUEUES",
  DASHBOARD_REPORT = "DASHBOARD_REPORT",
  FINDINGS_REPORT = "FINDINGS_REPORT",
  VIEW = "VIEW",
}

export type AutomationWizardStepProps = {
  defaultValues?: Record<string, any>;
  onValidate?: (data: Record<string, any>) => void;
  isSummary?: boolean;
};

export enum AUTOMATION_TRIGGER_TYPES {
  CRON = "CRON",

  EVENT = "EVENT",
}

type AutomationTrigger = {
  type: AUTOMATION_TRIGGER_TYPES;
  value: string;
};

type AutomationFiltersConfig = {
  filtersid?: string;
  scopesid?: string;
  scope_group?: string;
};

type AutomationAction = {
  type: AutomationTypeEnum;
  params: string;
};

type Automation = {
  id: string;
  name: string;
  trigger: AutomationTrigger;
  selection_rule: AutomationFiltersConfig;
  action: AutomationAction;
};

export type CreateAutomationVariables = Pick<
  Automation,
  "name" | "trigger" | "action"
> & {
  filters_config: AutomationFiltersConfig;
};

export type EditAutomationVariables = CreateAutomationVariables &
  Pick<Automation, "id">;

export interface AutomationFormBaseFields {
  filter?: {
    label?: string;
    value: {
      id?: string;
      query?: string;
    };
  };
  scope?: {
    value: {
      id: string;
    };
  };
  name: string;
  schedule: string;
}

export const validateAutomationData = (
  automation: any,
  validateParams: (params: any) => boolean
): boolean => {
  const isFiltersConfigValid =
    !!automation?.selection_rule?.filtersid &&
    (!!automation?.selection_rule?.scopesid ||
      !!automation?.selection_rule?.scope_group);

  const isTriggerValid =
    Object.keys(AUTOMATION_TRIGGER_TYPES).includes(automation?.trigger?.type) &&
    !!automation?.trigger?.value;

  const isActionParamsValid = validateParams(automation?.action?.params);

  const isActionValid =
    Object.keys(AutomationTypeEnum).includes(automation?.action?.type) &&
    isActionParamsValid;

  return (
    !!automation?.name &&
    isFiltersConfigValid &&
    isTriggerValid &&
    isActionValid
  );
};
